import { StoreBodyBlock } from 'constants/enums';

import { ETemplateStudioLayoutOptions } from 'components/TemplatesStudio/enums';

export type TemplateStudioAddBlockSectionRow = {
  id: string;
  title: string;
  description: string;
  badgeLabel?: string;
  onAdd: () => void;
};

export type TemplateStudioAddBlockSection = {
  id: string;
  label: string;
  rows: TemplateStudioAddBlockSectionRow[];
};

export type TemplateStudioAddBlockSectionDeps = Readonly<{
  enabledBlocks: StoreBodyBlock[];
  revealBlock: (block: StoreBodyBlock) => void;
  revealRollingWithLayout: (layout: ETemplateStudioLayoutOptions) => void;
}>;

export function resolveTemplateStudioAddBlockSections(
  deps: TemplateStudioAddBlockSectionDeps
): TemplateStudioAddBlockSection[] {
  const enabled = new Set(deps.enabledBlocks);
  const sections: TemplateStudioAddBlockSection[] = [];

  if (enabled.has(StoreBodyBlock.rollingOffers)) {
    sections.push({
      id: 'rolling-offer',
      label: 'Rolling offer',
      rows: [
        {
          id: 'rolling-standard',
          title: 'Rolling Offer (Standard)',
          description: 'Each unlocked offer reveals the next.',
          onAdd: () =>
            deps.revealRollingWithLayout(
              ETemplateStudioLayoutOptions.HORIZONTAL
            )
        },
        {
          id: 'rolling-one-many',
          title: 'Rolling Offer (1+Many)',
          description: 'Surface multiple rolling sequences together.',
          badgeLabel: 'S',
          onAdd: () =>
            deps.revealRollingWithLayout(ETemplateStudioLayoutOptions.VERTICAL)
        }
      ]
    });
  }

  return sections;
}
